import { IReview } from "api/interfaces/home/home.type.ts";
import BreadcrumbsMetaHead from "component/meta-header/BreadcrumbsMetaHead";
import LocalBusinessMeta from "component/meta-header/LocalBusinessMeta";
import { aggregateRatingMeta, getReviewMeta } from "component/meta-header/meta-utils";
import SiteLinkMeta from "component/meta-header/SiteLinkMeta";
import Head from "next/head";
import { useRouter } from "next/router";
import { homeMeta } from "resources/meta";
import FAQMetaHead from "component/meta-header/FAQMetaHead";
import OrganizationMetaHeader from "../../../component/meta-header/OrganizationMetaHeader";

const canonicalUrl = "https://partsavatar.ca";

interface IProps {
  reviews: IReview;
  aggregateRating: number;
  totalReviews: number;
}

function HomeMetaHeader(props: IProps) {
  const {
    reviews, aggregateRating, totalReviews, contentIds,
    meta: defaultMeta,
  } = props;

  const { locale } = useRouter();
  const meta = defaultMeta || homeMeta[locale];

  const microdata = {
    "@context": "http://schema.org",
    "@type": "Product",
    name: "Parts Avatar",
    url: meta.url || "https://partsavatar.ca/",
    aggregateRating: aggregateRatingMeta(reviews, aggregateRating, totalReviews),
    review: getReviewMeta(reviews),
  };

  return (
    <>

      <Head>

        <title>{meta.title}</title>

        <link rel="canonical" href={meta.url || canonicalUrl} />
        <link rel="alternate" hrefLang="en" href={canonicalUrl} />
        <link rel="alternate" hrefLang="fr" href={`${canonicalUrl}/fr`} />
        <link rel="alternate" hrefLang="x-default" href={canonicalUrl} />

        <meta name="description" content={meta.description} />
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=2.0" />

        <meta name="title" content={meta.meta.name.title} />

        <meta name="robots" content="INDEX,FOLLOW" />

        <meta name="publisher" content="Partsavatar.ca" />

        <meta name="keywords" content={meta.meta.name.keywords} />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(microdata) }}
        />

        <meta property="og:locale" content="en_CA" />
        <meta property="og:locale:alternate" content="en_CA" />
        <meta property="og:locale:alternate" content="fr_CA" />

        <meta property="og:title" content={meta.title} />

        <meta property="og:description" content={meta.description} />

        <meta property="og:url" content={canonicalUrl} />

        <meta property="og:site_name" content="PartsAvatar.ca" />

        <meta property="og:image" content={meta.image} />

        <meta name="twitter:card" content="summary_large_image" />

        <meta name="twitter:title" content={meta.title} />

        <meta name="twitter:description" content={meta.description} />
        <meta name="facebook-domain-verification" content="82cgyip0cz3a7igt87rjow5o8bf9th" />

        <meta name="twitter:image" content={meta.image} />
        <meta property="og:type" content="website" />
      </Head>
      <BreadcrumbsMetaHead />
      <SiteLinkMeta />
      <OrganizationMetaHeader />
      <LocalBusinessMeta />
      {contentIds && (
        <FAQMetaHead contentIds={contentIds} />
      )}

    </>
  );
}

export default HomeMetaHeader;
